import React from 'react'
import Image from 'react-image'
import { NavLink as Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import NoAvatar from 'assets/images/default-profile.png'
import ThreadStatus from './thread-status'

const Thread = ({ link, username, lastMessage, date, avatar, status, isRead }) => (
  <Link
    exact={true}
    to={link}
    className="lg:block inline-block py-2 bg-thread border-b"
    activeStyle={{ backgroundColor: '#ffffff' }}
    activeClassName="shadow-md"
  >
    <div className="flex justify-between items-center px-5 text-sm lg:mb-3">
      <ThreadStatus isRead={isRead} status={status} />
      <div className={`lg:block hidden date text-xs text-gray-700`}>{date}</div>
    </div>
    <div className="flex items-center">
      <div className="avatar px-2 mr-1">
        <Image
          src={[avatar, NoAvatar]}
          className="rounded-full object-cover md:w-14 md:h-14 w-10 h-10"
        />
      </div>
      <div className="w-3/4 lg:flex hidden flex-col py-2">
        <div
          className={`username truncate text-base mb-1 ${!isRead ? 'font-bold' : 'font-normal'}`}
        >
          {username}
        </div>
        <div
          className={`clamp-2 last-message text-xs ${
            !isRead ? 'font-bold' : 'text-gray-700 font-normal'
          }`}
        >
          {lastMessage}
        </div>
      </div>
    </div>
  </Link>
)

Thread.propTypes = {
  link: PropTypes.string,
  username: PropTypes.string,
  lastMessage: PropTypes.string,
  date: PropTypes.string,
  avatar: PropTypes.string,
  status: PropTypes.string,
  isRead: PropTypes.bool,
}

export default Thread
